import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as externalInstitutions from '../../../../external-institutions'
import * as sponsor from '../sponsor'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: sponsor.RESOURCE.payload.dimension.partialId,
      partialId: sponsor.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'TODO',
    isOptional: true,
    name: 'Institution',
    partialId: PartialId.Standard.create('institution'),
    type: {
      dimensionId: core.dms.models.Dimension.Id.from(
        externalInstitutions.RESOURCE.payload,
      ),
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
